import { render, staticRenderFns } from "./ExampleImage.vue?vue&type=template&id=3b3eff5e&scoped=true"
import script from "./ExampleImage.vue?vue&type=script&lang=js"
export * from "./ExampleImage.vue?vue&type=script&lang=js"
import style0 from "./ExampleImage.vue?vue&type=style&index=0&id=3b3eff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3eff5e",
  null
  
)

export default component.exports